export default {
    init() {
        let cta = document.querySelector('section.cta');
        let footer = document.querySelector('#footer');
        if(cta && footer) {
            const FOOTER_Y = window.pageYOffset + footer.getBoundingClientRect().top;
            const FOOTER_HEIGHT = footer.getBoundingClientRect().height;
            const FOOTER_OFFSET = 150;
            const MIN_SCROLL = 850;
            const MAX_SCROLL =  FOOTER_Y - FOOTER_HEIGHT - FOOTER_OFFSET;
            $(window).scroll(() => {
                var scroll_top = $(window).scrollTop();
                if(scroll_top > MIN_SCROLL && scroll_top < MAX_SCROLL) {
                    // header.classList.add('sticky');
                    cta.classList.add('sticky');
                    if(this.inside_map(scroll_top)) {
                        // cta.style.display = "none";
                        cta.classList.add('hidden');
                    } else {
                        // cta.style.display = "block"
                        cta.classList.remove('hidden');
                    }
                } else {
                    cta.classList.remove('sticky');
                    // cta.style.display = "none";
                    cta.classList.add('hidden');
                }
            });
        }
    },

    /**
     * Function to determine whether the user is currently viewing the map or not.
     * @returns {Boolean} Whether or not we are inside the maps co-ordinates
     */
    inside_map(scroll_top) {
        let map = document.getElementById('tab-map');
        //getting the scroll location of the map.
        if(map) {
            const MAP_OFFSET = 150;
            const MAP_HEIGHT = map.offsetHeight;
            const MAP_SCROLL = window.pageYOffset + map.getBoundingClientRect().top - MAP_HEIGHT;


            if(scroll_top >= MAP_SCROLL - MAP_OFFSET && scroll_top <= MAP_SCROLL + MAP_HEIGHT + MAP_OFFSET) {
                // window.scrollBy(0, 2);
                return true;
            } else {
                return false;
            }
        } else {
            return false;
        }
    }
}